const organization_details = {
    departments: {
        leader: '负责人',
        leaders: '部门负责人',
        led_departments: '负责的部门',
        edit_leaders: '设置负责人',
        add_leader: '添加',
        remove_leader: '移除',
        no_leaders: '未设置负责人',
        local: '本地设置',
        managed_members: '管理范围内成员',
        leader_scope_hint: '仅可管理负责部门及子部门的成员归属。',
        leader_permission_hint: '负责人可管理本部门及子部门的成员归属，不能修改组织角色或部门结构。',
        primary_synced: '主部门由飞书同步维护。',
        status_active: '在职',
        status_suspended: '已冻结',
        status_departed: '已离职',
        status_pending: '待激活',
        search: '搜索',
        previous_page: '上一页',
        next_page: '下一页',
        directory_title: '组织成员',
        member_name: '成员',
        search_members: '按姓名或用户名搜索',
        include_descendants: '包含子部门',
        no_members: '没有匹配的成员。',
        all_members: '全部成员',
        all_departments: '全部部门',
        edit_member: '编辑部门归属',
        add_child: '新建子部门',
        expand_department: '展开{{name}}',
        collapse_department: '收起{{name}}',
        title: '部门',
        description: '管理当前组织的部门及成员归属。',
        create: '新建部门',
        edit: '编辑部门',
        name: '部门名称',
        parent: '上级部门',
        root: '无上级部门',
        id: '部门 ID',
        members: '成员部门归属',
        member_id: '成员用户 ID',
        primary: '主部门',
        none: '未设置',
        assignments: '部门归属记录',
        no_assignments: '暂无部门归属记录。',
        assignment_hint: '分配本地部门，可设置一个主部门。通讯录同步的归属由来源维护。',
        empty: '暂无部门。',
        readonly: '你可以查看部门和自己的归属。如需变更，请联系组织管理员。',
        load_error: '加载失败，请重试。',
        mutation_error: '保存失败，请检查权限、成员归属及部门层级。',
        loading: '正在加载…',
        synced: '通讯录同步',
        choose: '搜索部门',
        organizations_title: '组织与部门',
        organizations_description: '选择组织，查看或管理其部门。',
        no_organizations: '你尚未加入组织，请联系组织管理员。',
        organization: '当前组织',
        choose_organization: '请选择组织',
        delete_title: '删除部门',
        delete_description: '确认删除“{{name}}”？请先移走该部门的成员和子部门。',
    },
    directory: {
        leaders_label: '负责人关系',
        local_department_leader: '本地设置的部门负责人',
        status_active: '在职',
        status_suspended: '已冻结',
        status_departed: '已离职',
        status_pending: '待激活',
        profiles_label: '来源资料',
        primary_label: '主部门变更',
        deactivated_label: '停用组织身份',
        reactivated_label: '恢复组织身份',
        lifecycle_notice: '保留角色关联 {{count}} 条。恢复身份后会恢复原有权限。',
        title: '飞书通讯录',
        description: '通过飞书连接器，将部门和成员导入当前组织。',
        identity_notice: '请使用已开启通讯录身份同步的连接器。更改既有连接器的身份标识前，需要处理账号迁移。',
        connector: '飞书连接器 ID',
        preview: '预览同步',
        preview_title: '同步预览',
        preview_description: '请核对通讯录内容；如内容发生变化，需要重新预览。',
        import: '确认同步',
        success: '已导入 {{departments}} 个部门、{{users}} 名成员，新增 {{createdUsers}} 个账号。 已移除 {{removedDepartments}} 个部门、{{removedMemberships}} 个组织成员身份、{{removedAssignments}} 条归属。',
        failure: '无法读取或导入通讯录。请检查连接器权限和可见范围，然后重新预览。',
        behavior_title: '导入方式',
        mode: '同步姓名、头像、部门及主部门。缺失或非在职成员仅停用当前组织身份；保留角色、手工归属、全局账号及其他组织身份。邮箱、手机仅作来源资料，不绑定为登录凭据。',
        limits: '每次最多 1000 个部门、5000 名用户、10000 条归属；读取限时 60 秒。内容不完整或超限时拒绝导入。',
        counts: '{{departments}} 个部门 · {{users}} 名成员',
        departments_label: '部门',
        members_label: '组织成员身份',
        assignments_label: '部门归属',
        item: '项目',
        added: '新增',
        updated: '更新',
        removed: '移除',
        cleanup_notice: '同步姓名、头像、部门及主部门。缺失或非在职成员仅停用当前组织身份；保留角色、手工归属、全局账号及其他组织身份。邮箱、手机仅作来源资料，不绑定为登录凭据。',
        conflicts_title: '存在 {{count}} 项冲突，暂不能同步。请先处理本地依赖，再重新预览。',
        removals_title: '移除项示例（每类最多展示 20 项）',
        local_child_department: '存在本地子部门',
        unowned_assignment: '存在本地或缺少来源标记的历史归属',
        local_member_roles: '成员存在本地分配的角色',
        unlinked_identity: '通讯录身份已解绑',
    },
    page_title: '机构详情',
    delete_confirmation: '一旦删除，所有成员将失去他们在这个机构中的成员资格和角色。此操作将无法撤销。',
    organization_id: '机构编号',
    settings_description: '机构代表可以访问您的应用程序的团队、业务客户和合作伙伴公司。',
    name_placeholder: '组织名称，不需要是唯一的。',
    description_placeholder: '机构的描述。',
    member: '成员',
    member_other: '成员',
    add_members_to_organization: '向机构{{name}}添加成员',
    add_members_to_organization_description: '通过姓名、电子邮件、电话或用户ID搜索合适的用户。搜索结果中不显示现有成员。',
    add_with_organization_role: '以机构角色加入',
    user: '用户',
    application: '应用',
    application_other: '应用',
    add_applications_to_organization: '向组织{{name}}添加应用',
    add_applications_to_organization_description: '通过搜索应用 ID、名称或描述来找到合适的应用。搜索结果中不显示现有应用。',
    at_least_one_application: '至少需要一个应用。',
    remove_application_from_organization: '从机构中移除应用',
    remove_application_from_organization_description: '一旦移除，应用将失去其在该机构中的关联和角色。此操作将无法撤销。',
    search_application_placeholder: '按应用 ID、名称或描述搜索',
    roles: '机构角色',
    authorize_to_roles: '授权{{name}}访问以下角色:',
    edit_organization_roles: '编辑机构角色',
    edit_organization_roles_title: '编辑{{name}}的机构角色',
    remove_user_from_organization: '从机构中移除用户',
    remove_user_from_organization_description: '一旦移除，用户将失去他们在这个机构中的成员资格和角色。此操作将无法撤销。',
    search_user_placeholder: '按名称、电子邮件、电话或用户ID搜索',
    at_least_one_user: '至少需要一个用户。',
    organization_roles_tooltip: '{{type}}在此机构中分配的角色。',
    custom_data: '自定义数据',
    custom_data_tip: '自定义数据是一个 JSON 对象，可用于存储与机构关联的附加数据。',
    invalid_json_object: '无效的 JSON 对象。',
    branding: {
        name: '品牌',
        description: '自定义你的机构级登录体验。',
        organization_level_sie: '机构级登录体验',
        organization_level_sie_switch: '启用机构级登录体验并设置机构专属品牌。若关闭，将首先回退到应用级登录体验，然后是通用登录体验。',
        logo: '机构标志',
        logo_tooltip: '你可以传递机构 ID 以在登录体验中显示此标志；如果在全套登录体验设置中启用了深色模式，则需要深色版本的标志。<a>了解更多</a>',
    },
    jit: {
        title: '即时供应',
        description: '用户可以在通过某些身份验证方法首次登录时自动加入机构并被分配角色。你可以设置即时供应的要求。',
        email_domain: '电子邮件域供应',
        email_domain_description: '新用户使用他们的验证电子邮件地址注册或通过验证电子邮件地址的社交登录，将自动加入机构。<a>了解更多</a>',
        email_domain_placeholder: '输入即时供应的电子邮件域',
        invalid_domain: '无效的域',
        domain_already_added: '域已添加',
        sso_enabled_domain_warning: '你输入了一个或多个与企业 SSO 关联的电子邮件域。使用这些电子邮件的用户将遵循标准的 SSO 流程，除非配置了企业 SSO 供应，否则不会被分配到该机构。',
        enterprise_sso: '企业 SSO 供应',
        no_enterprise_connector_set: '你尚未设置任何企业 SSO 连接器。首先添加连接器，以启用企业 SSO 供应。<a>设置</a>',
        add_enterprise_connector: '添加企业连接器',
        enterprise_sso_description: '通过企业 SSO 首次登录的新用户或现有用户将自动加入机构。<a>了解更多</a>',
        organization_roles: '默认机构角色',
        organization_roles_description: '通过即时供应加入机构时分配角色。',
    },
    mfa: {
        title: '多因素认证 (MFA)',
        tip: '当要求 MFA 时，没有配置 MFA 的用户在试图交换机构令牌时将被拒绝。此设置不影响用户身份验证。',
        description: '要求用户配置多因素认证才能访问此机构。',
        no_mfa_warning: '你的租户没有启用多因素认证方法。用户将无法访问此机构，直到启用至少一种<a>多因素认证方法</a>。',
    },
};
export default Object.freeze(organization_details);
